import React, { useState, useEffect } from 'react';

// =========================================================================
// CUSTOM HOOK: useExternalScriptManager
// Handles the injection, checking, and cleanup of external scripts
// =========================================================================
const TARGET_SCRIPT_ID = 'js_banners_cdandlp';
const TARGET_SCRIPT_URL = 'https://www.cdandlp.com/banners/js/affiliatebannerscdandlp.min.js?id=456154';

const useExternalScript = (id = TARGET_SCRIPT_ID, url = TARGET_SCRIPT_URL) => {

    // Status can be: 'checking', 'found', 'injecting', 'injected_and_loaded', 'error'
    const [status, setStatus] = useState('checking');

    useEffect(() => {
        let script = document.getElementById(id);

        if (script) {
            // 1. Script found: Assume it was loaded by another process/component
            script.remove();

            // setStatus('loaded');
        }

        // 2. Script is not found, so we need to inject it
        const newScript = document.createElement('script');
        newScript.id = id;
        newScript.type = 'text/javascript';
        newScript.src = url;

        // Set up event listeners to track script loading status
        newScript.onload = () => {
            setStatus('loaded');
            console.log(`[Hook] Script ${id} loaded successfully.`);
        };
        newScript.onerror = (e) => {
            setStatus('error');
            console.error(`[Hook] Failed to load script ${id}.`, e);
        };

        // Append the script to the <head> element to start loading

        document.head.appendChild(newScript);
        setStatus('injecting');


        // 3. Cleanup: remove the injected script when the component unmounts
        return () => {
            const cleanupScript = document.getElementById(id);
            // We only remove it if its source matches what we injected
            if (cleanupScript && cleanupScript.src === url) {
                cleanupScript.remove();
            }
        };

        // Note: id and url are dependencies, but since they are constants, the effect runs once.
    }, [id, url]);

    return status;
};
export {
    useExternalScript
}